module.exports = __webpack_public_path__ + "img/Y02B响应式详情.325f5234.jpg";